// extracted by mini-css-extract-plugin
export var centerText = "_6v-8";
export var container = "_6v-0";
export var doughnutContainer = "_6v-7";
export var legend = "_6v-a";
export var legendItemColorDisplay = "_6v-b";
export var legendItemLabel = "_6v-d";
export var legendItemValue = "_6v-c";
export var lg = "_6v-5";
export var maxWidth = "_6v-9";
export var md = "_6v-4";
export var responsive = "_6v-6";
export var sm = "_6v-3";
export var xs = "_6v-2";
export var xxs = "_6v-1";